import { render } from "./WealthRatingBlock.vue?vue&type=template&id=b903f304&scoped=true"
import script from "./WealthRatingBlock.vue?vue&type=script&lang=js"
export * from "./WealthRatingBlock.vue?vue&type=script&lang=js"

import "./WealthRatingBlock.vue?vue&type=style&index=0&id=b903f304&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b903f304"]])

export default __exports__